import store from '@/store/index';
import route from '@/routes/index';
import { alert as showAlert, hideLoading } from '@/plugins/dialog/api';
import { LoadingMixin } from '@/mixin/loading.js';

export function setInterceptors(instance) {
  // Add a request interceptor
  instance.interceptors.request.use(
    function(config) {
      // Do something before request is sentconfig.headers.userToken = store.state.token;
      config.headers.userToken = store.state.token;
      config.headers.authorization = store.state.token;
      config.headers.AJAX = true;
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  instance.interceptors.response.use(
    response => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    error => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      if (error.response.status === 598) {
        showAlert('허용되지 않는 파일 형식입니다.');
      }

      if (error.response.status === 401) {
        hideLoading();
        LoadingMixin.methods.hideLoading();
        store.dispatch('LOGOUT', store.getters.tenantKey);
        route.push({
          name: 'login',
          params: {
            tenantKey: store.getters.tenantKey,
          },
        });
      }

      return Promise.reject(error);
    },
  );

  return instance;
}
